
























import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryPlatformPvSummaryList, ExportPlatformPvSummary, ManualAdjustPlatformPv } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message } from 'element-ui'

@Component({
  components: {
    VQuery,
    VTable,
  },
})
export default class PlatformPvSummaryList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
    statDateDaterange:[],
    orderBy: 'stat_date desc',
    statDateTimeScope:'',
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1
  private platformPvDisplay: string | null = null
  private adjustVisible = false
  private adjustForm: any = { direction: 'INCREASE', pvYuan: 0, remark: '' }

  // 查询条件
  private queryModels: Array<QueryModel> = [{ title: '统计日期', param: 'statDateDaterange', type: 'daterange' }]
  // 全局操作
  private queryOperation: Array<TableOperation> = [{ title: '导出', type: 'warning', click: this.exportHandle }]
  // 数据表头 -
  private tableHander: Array<TableHander> = [
    { title: '多选', type: 'selection' },
    { title: '序号', param: 'id', type: 'index' },
    { title: '统计日期', param: 'statDate',width:120 },
    { title: '期初pv值', param: 'platformBeginPv' },
    { title: '期末pv值', param: 'platformEndPv' },
    { title: '平台PV总额', param: 'platformChangePv' },
    { title: '平台PV消耗', param: 'platformConsumePv' },
    { title: '平台PV获得', param: 'platformGainPv' },
    { title: '手动变更_平台PV', param: 'platformManualChangePv' },
    { title: '已结算订单退款_平台PV', param: 'platformOrderRefundPv' },
    { title: '订单产生PV', param: 'orderPv' },
    { title: '代理PV消耗', param: 'agentConsumePv' },
    { title: '店铺推荐奖励PV消耗', param: 'shopInviteConsumePv' },
    { title: '统计时平台剩余PV', param: 'platformSurplusPv' },
    { title: '统计时平台历史总PV', param: 'platformHisTotalPv' },

    { title: '数据更新时间', param: 'updateTime', formatter: DateFormat,width:160 },
    {
      title: '操作',
      fixed: 'right',
      operation: [
        { title: '查看明细' , click: this.jumpTo },
      ],
    },
  ]

  private jumpTo(data: any){
    // 跳转到数据源，用户积分记录，加入查询条件，和查询一直
    this.$router.push({
      path: "/platformWealthRecordList",
      query:{
        createTime: data.statDate
      }
    })
  }

  private tableSelectData: any[] = []
  private tableSelectChange(e:any[]){
    this.tableSelectData = e
  }
  private exportHandle(){

    const loading = this.$loading({
          lock: true,
          text: '正在导出',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      const param: any = this.getRequestParam()
      param.limit = ""
      param.startRow = ""

      if(this.tableSelectData.length > 0){
        const ids = this.tableSelectData.map(e=>e.id)
        param.ids = ids
      }


      ExportPlatformPvSummary(param,"每日平台PV数据统计.xlsx").then(res=>{
        loading.close()
      }).catch(()=>{
        loading.close()
      })

  }

  public async created() {
    this.loadData()
    this.loadLatestPlatformPv()
  }

  private async loadLatestPlatformPv() {
    const result = await QueryPlatformPvSummaryList({ startRow: 0, limit: 1, orderBy: 'stat_date desc' })
    const row = result && result.list && result.list[0]
    if (row && row.platformSurplusPv != null) {
      this.platformPvDisplay = String(row.platformSurplusPv)
    }
  }

  private openAdjustDialog() {
    this.adjustForm = { direction: 'INCREASE', pvYuan: 0, remark: '' }
    this.adjustVisible = true
  }

  private async submitAdjust() {
    if (!this.adjustForm.pvYuan || this.adjustForm.pvYuan <= 0) {
      Message.warning('请输入大于0的金额')
      return
    }
    if (!this.adjustForm.remark || !String(this.adjustForm.remark).trim()) {
      Message.warning('请填写备注')
      return
    }
    const res = await ManualAdjustPlatformPv({
      direction: this.adjustForm.direction,
      pvYuan: this.adjustForm.pvYuan,
      remark: this.adjustForm.remark,
    })
    if (res && res.pv != null) {
      this.platformPvDisplay = (Number(res.pv) / 100).toFixed(2)
    }
    Message.success('调账成功')
    this.adjustVisible = false
    this.loadData()
  }


  public async loadData() {
    const param = this.getRequestParam()
    const result = await QueryPlatformPvSummaryList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }
  private getRequestParam(){
    const param = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    if (param.statDateDaterange.length >0) {
      param.statDateTimeScope = DateFormat(param.statDateDaterange[0]) + ',' + DateFormat(param.statDateDaterange[1])
    }
    return param
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
